"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const filters = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-filters` : '') + (description ? ` desc-filters` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-filters"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-filters"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 13.25C11.0913 13.25 12.8298 14.7605 13.184 16.75L22.5 16.75C22.9142 16.75 23.25 17.0858 23.25 17.5C23.25 17.8797 22.9678 18.1935 22.6018 18.2432L22.5 18.25L13.1839 18.251C12.8292 20.24 11.0909 21.75 9 21.75C6.90906 21.75 5.17079 20.24 4.81615 18.251L1.5 18.25C1.08579 18.25 0.75 17.9142 0.75 17.5C0.75 17.1203 1.03215 16.8065 1.39823 16.7568L1.5 16.75L4.81597 16.75C5.17021 14.7605 6.90871 13.25 9 13.25ZM9 14.75C7.48122 14.75 6.25 15.9812 6.25 17.5C6.25 19.0188 7.48122 20.25 9 20.25C10.5188 20.25 11.75 19.0188 11.75 17.5C11.75 15.9812 10.5188 14.75 9 14.75ZM15.5 2.25C17.5913 2.25 19.3298 3.76048 19.684 5.74998L22.5 5.75C22.9142 5.75 23.25 6.08579 23.25 6.5C23.25 6.8797 22.9678 7.19349 22.6018 7.24315L22.5 7.25L19.6839 7.25101C19.3292 9.24002 17.5909 10.75 15.5 10.75C13.4091 10.75 11.6708 9.24002 11.3161 7.25101L1.5 7.25C1.08579 7.25 0.75 6.91421 0.75 6.5C0.75 6.1203 1.03215 5.80651 1.39823 5.75685L1.5 5.75L11.316 5.74998C11.6702 3.76048 13.4087 2.25 15.5 2.25ZM15.5 3.75C13.9812 3.75 12.75 4.98122 12.75 6.5C12.75 8.01878 13.9812 9.25 15.5 9.25C17.0188 9.25 18.25 8.01878 18.25 6.5C18.25 4.98122 17.0188 3.75 15.5 3.75Z",
    fill: "inherit"
  }));
};
var _default = exports.default = filters;